<template>
    <div>
            <div class="panel ">
 

                <div class="panel-heading">
                    <nav class="level is-mobile">
                        <div class="level-left">
                            <div class="level-item">
                                Recent Images Nonautomate Lab
                            </div>

                        </div>
                        <div class="level-right">

                            <div class="level-item">
                                <b-tooltip label="Reload/Renew All Recent">
                                <b-button type="is-primary  is-light" outlined
                                          icon-right="refresh" :disabled="imagesLoading" @click="refreshImageNonRecently"/>
                                </b-tooltip>
                            </div>
                        </div>
                    </nav>
                </div>
                <div class="">
 



   
            <div v-if="imagesLoading" role="status" class="p-4">
                <b-icon icon="loading" custom-class="mdi-spin" />
                {{ imagesArrRecently.length ? 'กำลังอัปเดตภาพล่าสุด…' : 'กำลังโหลดภาพล่าสุด…' }}
            </div>
            <b-notification v-if="imagesError" type="is-warning" :closable="false">
                {{ imagesError }}
                <b-button :disabled="imagesLoading" @click="retryImages">ลองใหม่</b-button>
            </b-notification>
            <p v-if="imagesLoaded && !imagesLoading && !imagesError && !imagesArrRecently.length" class="p-4">ยังไม่มีภาพล่าสุด</p>
            <b-tabs v-if="imagesArrRecently.length" v-model="activeTabViewImagesModel">
                    <b-tab-item label="View As Images Series">
                        <ImagesLABNonRecently_ViewImagesSeries 
                          @showLab="showLab"
                          @loadMoreDataImagesRecently="loadDataMore" />
                    </b-tab-item>
                    <b-tab-item label="View As LAB ID">
                        <ImagesLABNonRecently_ViewGrpIDLab 
                           @showLab="showLab"
                           @loadMoreDataImagesRecently="loadDataMore" />
                    </b-tab-item>
            </b-tabs>        
 
            

             

        
                </div>
            </div>
    </div>
</template>


<script>
import { mapActions , mapMutations, mapState } from "vuex";
import ImagesLABNonRecently_ViewGrpIDLab from './ImagesLABNonRecently_ViewGrpIDLab.vue'
import ImagesLABNonRecently_ViewImagesSeries from './ImagesLABNonRecently_ViewImagesSeries.vue'



export default {
    name : "ImagesLABNonRecently",
 
    components:{
      ImagesLABNonRecently_ViewGrpIDLab,
      ImagesLABNonRecently_ViewImagesSeries,
    },
    mounted() { this.$store.dispatch('home/loadRecentImages') },
    computed:{
        ...mapState({
            imagesLoaded: state => state.home.imagesLoaded,
            imagesLoading: state => state.home.imagesLoading,
            imagesError: state => state.home.imagesError,
            imagesRequestMode: state => state.home.imagesRequestMode,
            imagesArrRecently : state => state.home.imagesArrRecently ,
            firstImagesArrRecently : state => state.home.firstImagesArrRecently ,
            skipImagesArrRecently : state => state.home.skipImagesArrRecently ,

            activeTabViewImages: state => state.home.activeTabViewImages ,
            isMoreBtnLoading : state => state.home.isMoreBtnLoading ,
        }),
        activeTabViewImagesModel:{
                get: function () {
                    return this.activeTabViewImages
                },
                set: function (newValue) {
                    this.setActiveTabViewImages(newValue)
                }
        },
        isMoreBtnLoadingModel:{
                get: function () {
                    return this.isMoreBtnLoading
                },
                set: function (newValue) {
                    this.setIsMoreBtnLoading(newValue)
                }
        },
    },    
    methods:{
         ...mapMutations({
            setClearImagesArrRecently : 'home/setClearImagesArrRecently',
            setFirstImagesArrRecently : 'home/setFirstImagesArrRecently',
            setSkipImagesArrRecently : 'home/setSkipImagesArrRecently',
            setActiveTabViewImages: 'home/setActiveTabViewImages',
            setIsMoreBtnLoading : 'home/setIsMoreBtnLoading',
        }),
         ...mapActions({
            fetchImagesRecently : 'home/fetchImagesRecently',
        }),


        refreshImageNonRecently(){ return this.$store.dispatch('home/loadRecentImages', 'refresh') },
        retryImages(){ return this.$store.dispatch('home/loadRecentImages', this.imagesRequestMode) },
        loadDataMore(){ return this.$store.dispatch('home/loadRecentImages', 'more') },
        showLab(payload){
            this.$emit('showLab',payload)
        }

         
    },
    data(){
        return{
            perPage : 10,
            currentPage : 1,
         //   activeTabViewImages : 0,
        }
    }
}
</script>


<style scoped>
    img{
        cursor: pointer;
        width:100%;
        height:100%;
        object-fit: contain;

    }
    /*.card{*/
    /*    border: 5px solid #555;*/
    /*}*/



</style>